import {axiosInstance} from '../contexts/AxiosProvider';
import {ImageCategory} from "../types/image-category";

export const getImagesByCategoryId = async () => {
    const result = await axiosInstance.get<ImageCategory[]>("/images");
    return result.data;
}
